module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-empty', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.row.subject_list.length == 0),
      expression: "row.subject_list.length==0"
    }],
    attrs: {
      "description": "没有项目信息"
    }
  }), _vm._v(" "), _c('van-cell-group', _vm._l((_vm.row.subject_list), function(subject, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "title": '项目' + (index + 1)
      },
      on: {
        "click": function($event) {
          return _vm.jump(subject)
        }
      },
      scopedSlots: _vm._u([{
        key: "right-icon",
        fn: function() {
          return [_c('div', [(subject.jizan_count == 0) ? _c('div', {
            staticClass: "tiny-btn-1"
          }, [_vm._v("上传集赞数据")]) : _c('div', {
            staticClass: "tiny-btn-0"
          }, [_vm._v("集赞数据已上传")])])]
        },
        proxy: true
      }, {
        key: "label",
        fn: function() {
          return [_c('div', [_vm._v(_vm._s(subject.subject_name))]), _vm._v(" "), _c('div', [_vm._v("\n                    运动员:\n                    "), _vm._l((subject.yundongyuan), function(member, index) {
            return _c('span', {
              key: index,
              staticStyle: {
                "color": "#111"
              }
            }, [_vm._v(_vm._s(member.name) + " ")])
          })], 2)]
        },
        proxy: true
      }], null, true)
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3bcd5b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/zsai/SaiApplyZanList.vue
// module id = 2599
// module chunks = 0